import React, { useState } from 'react';
import { AdminHeader } from './components/AdminHeader';
import { CreateNoticeForm } from './components/CreateNoticeForm';
import { Sidebar } from './components/Sidebar';
import { RequetesModule } from './components/RequetesModule';
import { PermisModule } from './components/PermisModule';
import { LoisirsModule } from './components/LoisirsModule';
import { BcitiIdModule } from './components/BcitiIdModule';
import { BcitiCollectesModule } from './components/BcitiCollectesModule';
import { BcitiCompteursModule } from './components/BcitiCompteursModule';
import { AtnaModule } from './components/AtnaModule';
import { SettingsModule } from './components/SettingsModule';
import { ReleaseNotesModule } from './components/ReleaseNotesModule';
import { useScreenInit } from './useScreenInit.js';
import { LanguageProvider } from './contexts/LanguageContext';
import { CityProvider } from './contexts/CityContext';
import { AccountProvider } from './contexts/AccountContext';
import type { FeatureTarget } from './utils/releaseTryTarget';
export function App() {
  const screenInit = useScreenInit();
  const [activeTab, setActiveTab] = useState(screenInit.activeTab ?? 'requetes');
  /** Set when a release note's "Essayer" button opens a specific spot. */
  const [target, setTarget] = useState<FeatureTarget | null>(null);
  /** Bumped on every "Essayer" so the target module remounts on the right sub-tab. */
  const [navKey, setNavKey] = useState(0);
  const changeTab = (tab: string) => {
    setTarget(null);
    setActiveTab(tab);
  };
  const tryFeature = (next: FeatureTarget) => {
    setTarget(next);
    setNavKey(k => k + 1);
    setActiveTab(next.tab);
  };
  return <LanguageProvider data-id="element-0" data-mp="3dkuws5pznmst">
      <CityProvider data-id="element-1" data-mp="3dle4ktlxcut4">
      <AccountProvider data-id="element-2" data-mp="3dlntedv8gvx8">
      <div className="min-h-screen bg-[#F8FAFC] font-body text-slate-900 flex flex-col h-screen" data-id="element-3" data-mp="3dm6064fiusje">
        <AdminHeader data-id="element-4" data-mp="nvas7sh8xhgn" />
        <div className="flex flex-1 overflow-hidden" data-id="element-5" data-mp="nxx0jubyo0zx">
          <Sidebar activeTab={activeTab} onTabChange={changeTab} data-id="element-6" data-mp="stc7e2bjwwmu" />
          <main className="flex-1 overflow-y-auto" data-id="element-7" data-mp="35ypel6klo1z">
            {activeTab === 'requetes' ? <RequetesModule key={navKey} initialSubTab={target?.subTab} data-id="element-8" data-mp="3udawg7dqol46" /> : activeTab === 'permis' ? <PermisModule data-id="element-9" data-mp="d3mlpfjtr3m9" /> : activeTab === 'bciti-id' ? <BcitiIdModule data-id="element-10" data-mp="85uktw17c75x" /> : activeTab === 'loisirs' ? <LoisirsModule data-id="element-11" data-mp="83qhpgb4nc6p" /> : activeTab === 'collectes' ? <BcitiCollectesModule data-id="element-12" data-mp="3glnze5bz38kc" /> : activeTab === 'compteurs' ? <BcitiCompteursModule data-id="element-13" data-mp="3bnmf5h2t937a" /> : activeTab === 'atna' ? <AtnaModule data-id="element-14" data-mp="3qbfvj3zq09qx" /> : activeTab === 'release-notes' ? <ReleaseNotesModule onTryFeature={tryFeature} data-id="element-15" data-mp="3lkr4fprydesb" /> : activeTab === 'settings' ? <SettingsModule data-id="element-16" data-mp="2xudaftpt55v3" /> : <CreateNoticeForm key={navKey} initialSubTab={target?.subTab} initialView={target?.view} data-id="element-17" data-mp="2xt2900ju4a75" />}
          </main>
        </div>
      </div>
      </AccountProvider>
      </CityProvider>
    </LanguageProvider>;
}